module.exports = __webpack_public_path__ + "media/images/crypto-currencies/neo-58d96217f8297bbe80015bc7ca2406da.svg";